import * as React from "react";
import { createRoot, Root } from "react-dom/client";
import { ResolveContext , RouteResult } from "universal-router";
import { Sendum } from "../Sendum";

import { CognitoContainerRouter } from "./CognitoContainerRouter";
import NotFoundComponent from "./components/errors/NotFoundComponent";
import { RootComponent } from "./components/RootComponent";
import HeaderComponent from "./components/HeaderComponent";
import { TContainerRenderOptions } from "./types/TContainerRenderOptions";
import { TPage } from "./types/TPage";

const CONTENT_ID = "RootCognitoContainerContentComponent";
let widgetRoot: Root| undefined;

const init = async (options: TContainerRenderOptions): Promise<void> => {
	const cognitoContainer = document.getElementById(CONTENT_ID);
	if (!cognitoContainer) {
		widgetRoot = undefined;
		const header: JSX.Element = options.header || <HeaderComponent />;
		const template: JSX.Element = <RootComponent contentId={CONTENT_ID} header={header} />;
		const container = document.getElementById("root");
		const root = createRoot(container!);
		root.render(template);
		await new Promise(r => setTimeout(r, 500));
	}
};

export const cognitoContainerRender = async (browserLocation: string | ResolveContext, options: TContainerRenderOptions): Promise<void> => {
	Sendum.init({});
	await init(options);

	const router = CognitoContainerRouter.getRouter(options.routes);
	const page: RouteResult<TPage> = await router.resolve(browserLocation);

	if (page?.redirect) {
		Sendum.getBrowserHistory().push(page.redirect);

		return;
	}

	const element: JSX.Element = page?.content ? page.content : NotFoundComponent;

	if (!widgetRoot) {
		const container = document.getElementById(CONTENT_ID);
		if (container) {
			widgetRoot = createRoot(container);
		}
	}

	if (widgetRoot) {
		widgetRoot.render(element);
	}
};

export type { IRoute } from "./types/IRoute";
